import {
  FETCH_CUSTOMERS_DATA,
  FETCH_CUSTOMERS_SUCCESS,
  FETCH_CUSTOMERS_FAILURE,
} from "./actionTypes";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const customers = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CUSTOMERS_DATA:
      return { ...state, loading: true, error: null };
    case FETCH_CUSTOMERS_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_CUSTOMERS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default customers;
